/* eslint-disable camelcase */
const dragGridBase = [80, 44]
const dragGridBoard = [4, 44]
const dragGridBox = [2, 2]

const base = document.location.origin === 'http://localhost:3000'
  ? 'https://local.gassien.com/wp-content/plugins/gassien-maker/widget/build'
  : process.env.PUBLIC_URL

// Box type components
export const box = {
  type: 'box',
  name: 'Placeholder',
  dragGrid: dragGridBox,
}

// Image components
export const gridGF = {
  type: 'base',
  name: 'Grille GF',
  width: 320,
  height: 308,
  offsetX: 0,
  offsetY: 0,
  offsetHeight: 0,
  offsetWidth: 0,
  image: `${base}/img/gf.png`,
  zIndex: 2,
  dragGrid: dragGridBase,
  realWidthBase: 80,
  realHeightBase: 77,
}

export const gridMF = {
  type: 'base',
  name: 'Grille MF',
  width: 240,
  height: 308,
  offsetX: 0,
  offsetY: 0,
  offsetHeight: 0,
  offsetWidth: 0,
  image: `${base}/img/mf.png`,
  zIndex: 2,
  dragGrid: dragGridBase,
  realWidthBase: 60,
  realHeightBase: 77,
}

export const gridPF = {
  type: 'base',
  name: 'Grille PF',
  width: 160,
  height: 308,
  offsetX: 0,
  offsetY: 0,
  offsetHeight: 0,
  offsetWidth: 0,
  image: `${base}/img/pf.png`,
  zIndex: 2,
  dragGrid: dragGridBase,
  realWidthBase: 40,
  realHeightBase: 77,
}

export const gridGS = {
  type: 'base',
  name: 'Grille GS',
  width: 320,
  height: 176,
  offsetX: 0,
  offsetY: 0,
  offsetHeight: 0,
  offsetWidth: 0,
  image: `${base}/img/gs.png`,
  zIndex: 2,
  dragGrid: dragGridBase,
  realWidthBase: 80,
  realHeightBase: 44,
}

export const gridMS = {
  type: 'base',
  name: 'Grille MF',
  width: 240,
  height: 176,
  offsetX: 0,
  offsetY: 0,
  offsetHeight: 0,
  offsetWidth: 0,
  image: `${base}/img/ms.png`,
  zIndex: 2,
  dragGrid: dragGridBase,
  realWidthBase: 60,
  realHeightBase: 44,
}

export const board40x15 = {
  type: 'board',
  name: 'Planche 40x15',
  width: 180,
  height: 84,
  offsetX: 24,
  offsetY: 10,
  offsetHeight: 10,
  offsetWidth: 0,
  image: `${base}/img/board40x15.png`,
  dragGrid: dragGridBoard,
  realWidth: 40,
  realDepth: 15,
}
export const board60x15 = {
  type: 'board',
  name: 'Planche 60x15',
  width: 260,
  height: 84,
  offsetX: 20,
  offsetY: 10,
  offsetHeight: 20,
  offsetWidth: 4,
  image: `${base}/img/board60x15.png`,
  dragGrid: dragGridBoard,
  realWidth: 60,
  realDepth: 15,
}

export const board80x15 = {
  type: 'board',
  name: 'Planche 80x15',
  width: 340,
  height: 84,
  offsetX: 24,
  offsetY: 10,
  offsetHeight: 10,
  offsetWidth: 0,
  image: `${base}/img/board80x15.png`,
  dragGrid: dragGridBoard,
  realWidth: 80,
  realDepth: 15,
}
export const board40x20 = {
  type: 'board',
  name: 'Planche 40x20',
  width: 188,
  height: 88,
  offsetX: 28,
  offsetY: 0,
  offsetHeight: 10,
  offsetWidth: 4,
  image: `${base}/img/board40x20.png`,
  dragGrid: dragGridBoard,
  realWidth: 40,
  realDepth: 20,
}

export const board60x20 = {
  type: 'board',
  name: 'Planche 60x20',
  width: 266,
  height: 88,
  offsetX: 28,
  offsetY: 0,
  offsetHeight: 10,
  offsetWidth: 4,
  image: `${base}/img/board60x20.png`,
  dragGrid: dragGridBoard,
  realWidth: 60,
  realDepth: 20,
}

export const board80x20 = {
  type: 'board',
  name: 'Planche 80x20',
  width: 344,
  height: 88,
  offsetX: 30,
  offsetY: 0,
  offsetHeight: 10,
  offsetWidth: 4,
  image: `${base}/img/board80x20.png`,
  dragGrid: dragGridBoard,
  realWidth: 80,
  realDepth: 20,
}

export const board60x30_t2 = {
  type: 'board',
  name: 'Planche 60x30 T2',
  width: 284,
  height: 144,
  offsetX: 50,
  offsetY: 44,
  offsetHeight: 20,
  offsetWidth: 6,
  image: `${base}/img/board60x30_t2.png`,
  dragGrid: dragGridBoard,
  realWidth: 60,
  realDepth: 30,
}

export const board60x30_t3 = {
  type: 'board',
  name: 'Planche 60x30 T3',
  refName: 'planche_60_30',
  width: 284,
  height: 144,
  offsetX: 48,
  offsetY: 0,
  offsetHeight: 20,
  offsetWidth: 6,
  image: `${base}/img/board60x30_t3.png`,
  dragGrid: dragGridBoard,
  realWidth: 60,
  realDepth: 30,
}

export const board60x30_t2_right = {
  type: 'board',
  name: 'Planche 60x30 T2 DROITE',
  width: 284,
  height: 144,
  offsetX: 48,
  offsetY: 0,
  offsetHeight: 100,
  offsetWidth: 0,
  image: `${base}/img/board60x30_t2_right.png`,
  dragGrid: dragGridBoard,
  realWidth: 60,
  realDepth: 30,
}

export const board60x30_t2_left = {
  type: 'board',
  name: 'Planche 60x30 T2 GAUCHE',
  width: 284,
  height: 144,
  offsetX: 48,
  offsetY: 0,
  offsetHeight: 100,
  offsetWidth: 0,
  image: `${base}/img/board60x30_t2_left.png`,
  dragGrid: dragGridBoard,
  realWidth: 60,
  realDepth: 30,
}

export const potHolder_11 = {
  type: 'accessories',
  name: 'Porte pot 11',
  width: 47,
  height: 42,
  image: `${base}/img/potHolder.png`,
  dragGrid: dragGridBoard,
  realDiameter: 11,
}

export const potHolder_11_with_pot = {
  type: 'accessories',
  name: 'Porte pot 11 (pot)',
  width: 47,
  height: 72,
  image: `${base}/img/potHolder11_withPot.png`,
  dragGrid: dragGridBoard,
  realDiameter: 11,
}

export const potHolder_15 = {
  type: 'accessories',
  name: 'Porte pot 15',
  width: 64,
  height: 84,
  image: `${base}/img/potHolder15_withPot.png`,
  dragGrid: dragGridBoard,
  realDiameter: 15,
}

export const potHolder_15_with_pot = {
  type: 'accessories',
  name: 'Porte pot 15',
  width: 64,
  height: 84,
  image: `${base}/img/potHolder15_withPot.png`,
  dragGrid: dragGridBoard,
  realDiameter: 15,
}

export const hooks = {
  type: 'accessories',
  name: 'Crochets',
  width: 52,
  height: 84,
  image: `${base}/img/hooks.png`,
  dragGrid: dragGridBoard,
}

export const vaseHolder_10 = {
  type: 'accessories',
  name: 'Porte vase 10',
  width: 54,
  height: 46,
  image: `${base}/img/pvase10.png`,
  dragGrid: dragGridBoard,
  realWidth: 10,
}

export const vaseHolder_15 = {
  type: 'accessories',
  name: 'Porte vase 15',
  width: 84,
  height: 50,
  image: `${base}/img/pvase15.png`,
  dragGrid: dragGridBoard,
  realWidth: 15,
}

export const frameHolder_40 = {
  type: 'accessories',
  name: 'Porte cadre 40',
  width: 190,
  height: 46,
  image: `${base}/img/pcadre40.png`,
  dragGrid: dragGridBoard,
  realWidth: 40,
  realDepth: 10,
}

export const computerHolder = {
  type: 'accessories',
  name: 'Porte ordinateur',
  width: 120,
  height: 90,
  image: `${base}/img/pordi.png`,
  dragGrid: dragGridBoard,
  realWidth: 22,
  realDepth: 25,

}

export const hangerHolder = {
  type: 'accessories',
  name: 'Porte Cintre',
  width: 100,
  height: 120,
  image: `${base}/img/hangerHolder.png`,
  dragGrid: dragGridBoard,
  realDepth: 30,
}

export const glassesHolder_with_glasses = {
  type: 'accessories',
  name: 'Lot de 3 racks à verres',
  width: 120,
  height: 90,
  image: `${base}/img/glassesHolders_withGlasses.png`,
  dragGrid: dragGridBoard,
  realDepth: 20,
}

export const ps40 = {
  type: 'accessories',
  name: 'Porte Serviette 40',
  width: 162,
  height: 30,
  image: `${base}/img/ps40.png`,
  dragGrid: dragGridBoard,
  realWidth: 40,
}

export const ps60 = {
  type: 'accessories',
  name: 'Porte Serviette 60',
  width: 243,
  height: 30,
  image: `${base}/img/ps60.png`,
  dragGrid: dragGridBoard,
  realWidth: 60,
}

export const board80x30_t2 = {
  type: 'board',
  name: 'Planche 80x30 T2',
  width: 362,
  height: 142,
  offsetX: 50,
  offsetY: 44,
  offsetHeight: 20,
  offsetWidth: 6,
  image: `${base}/img/board80x30_t2.png`,
  dragGrid: dragGridBoard,
  realWidth: 80,
  realDepth: 30,
}

export const board80x30_t2_right = {
  type: 'board',
  name: 'Planche 80x30 T2 DROITE',
  width: 362,
  height: 142,
  offsetX: 48,
  offsetY: 0,
  offsetHeight: 100,
  offsetWidth: 0,
  image: `${base}/img/board80x30_t2_right.png`,
  dragGrid: dragGridBoard,
  realWidth: 80,
  realDepth: 30,
}

export const board80x30_t2_left = {
  type: 'board',
  name: 'Planche 80x30 T2 GAUCHE',
  width: 362,
  height: 142,
  offsetX: 48,
  offsetY: 0,
  offsetHeight: 100,
  offsetWidth: 0,
  image: `${base}/img/board80x30_t2_left.png`,
  dragGrid: dragGridBoard,
  realWidth: 80,
  realDepth: 30,
}

export const board80x30_t3 = {
  type: 'board',
  name: 'Planche 80x30 T3',
  width: 362,
  height: 142,
  offsetX: 48,
  offsetY: 0,
  offsetHeight: 20,
  offsetWidth: 6,
  image: `${base}/img/board80x30_t3.png`,
  dragGrid: dragGridBoard,
  realWidth: 80,
  realDepth: 30,
}

export const desk80x50 = {
  type: 'board',
  name: 'Desk 80x50',
  width: 402,
  height: 164,
  offsetX: 82,
  offsetY: 0,
  offsetHeight: 40,
  offsetWidth: 14,
  image: `${base}/img/desk80x50.png`,
  dragGrid: dragGridBoard,
  realWidth: 80,
  realDepth: 50,
}

export const desk60x50 = {
  type: 'board',
  name: 'Desk 60x50',
  width: 320,
  height: 164,
  offsetX: 82,
  offsetY: 0,
  offsetHeight: 40,
  offsetWidth: 14,
  image: `${base}/img/desk60x50.png`,
  dragGrid: dragGridBoard,
  realWidth: 60,
  realDepth: 50,
}

export const wardrobe40_with_hanger = {
  type: 'board',
  name: 'Penderie L.40cm',
  width: 160,
  height: 106,
  offsetX: 60,
  offsetY: 10,
  offsetHeight: 20,
  offsetWidth: 28,
  image: `${base}/img/wardrobe40_with_hanger.png`,
  dragGrid: dragGridBoard,
  realWidth: 40,
  realDepth: 30,
}

export const wardrobe60_with_hanger = {
  type: 'board',
  name: 'Penderie L.60cm',
  width: 240,
  height: 106,
  offsetX: 60,
  offsetY: 10,
  offsetHeight: 20,
  offsetWidth: 28,
  image: `${base}/img/wardrobe60_with_hanger.png`,
  dragGrid: dragGridBoard,
  realWidth: 60,
  realDepth: 30,
}

export const wardrobe80_with_hanger = {
  type: 'board',
  name: 'Penderie L.80cm',
  width: 320,
  height: 106,
  offsetX: 60,
  offsetY: 10,
  offsetHeight: 20,
  offsetWidth: 28,
  image: `${base}/img/wardrobe80_with_hanger.png`,
  dragGrid: dragGridBoard,
  realWidth: 80,
  realDepth: 30,
}

export const zenith_1_ppot = {
  type: 'accessories',
  name: 'Lampe Zenith / Support PPOT',
  width: 56,
  height: 96,
  offsetX: 0,
  offsetY: 0,
  offsetHeight: 0,
  offsetWidth: 0,
  image: `${base}/img/bom/lampe-zenith-portepot.png`,
  dragGrid: dragGridBoard,
}

export const zenith_1_pver = {
  type: 'accessories',
  name: 'Lampe Zenith / Support PVER',
  width: 50,
  height: 148,
  offsetX: 0,
  offsetY: 0,
  offsetHeight: 0,
  offsetWidth: 0,
  image: `${base}/img/bom/lampe-zenith-broche.png`,
  dragGrid: dragGridBoard,
}
export const halo_2_ppot = {
  type: 'accessories',
  name: 'Lampe Halo / Support PPOT',
  width: 56,
  height: 106,
  offsetX: 0,
  offsetY: 0,
  offsetHeight: 0,
  offsetWidth: 0,
  image: `${base}/img/bom/lampe-halo-portepot.png`,
  dragGrid: dragGridBoard,
}

export const halo_2_pver = {
  type: 'accessories',
  name: 'Lampe Halo / Support PVER',
  width: 56,
  height: 158,
  offsetX: 0,
  offsetY: 0,
  offsetHeight: 0,
  offsetWidth: 0,
  image: `${base}/img/bom/lampe-halo-broche.png`,
  dragGrid: dragGridBoard,
}
export const lumi_1 = {
  type: 'accessories',
  name: 'Vase Lumi',
  width: 48,
  height: 86,
  offsetX: 0,
  offsetY: 0,
  offsetHeight: 0,
  offsetWidth: 0,
  image: `${base}/img/bom/vase-lumi.png`,
  dragGrid: dragGridBoard,
  realWidth: 12,
  realheight: 15,
}

export const flux_2 = {
  type: 'accessories',
  name: 'Vase Flux',
  width: 48,
  height: 124,
  offsetX: 0,
  offsetY: 0,
  offsetHeight: 0,
  offsetWidth: 0,
  image: `${base}/img/bom/vase-flux.png`,
  dragGrid: dragGridBoard,
}
export const echo_1 = {
  type: 'accessories',
  name: 'Miroir Echo',
  width: 92,
  height: 124,
  offsetX: 0,
  offsetY: 0,
  offsetHeight: 0,
  offsetWidth: 0,
  image: `${base}/img/bom/miroir-echo.png`,
  dragGrid: dragGridBoard,
}

export const onde_2 = {
  type: 'accessories',
  name: 'Miroir Onde',
  width: 92,
  height: 118,
  offsetX: 0,
  offsetY: 0,
  offsetHeight: 0,
  offsetWidth: 0,
  image: `${base}/img/bom/miroir-onde.png`,
  dragGrid: dragGridBoard,
}

export const tables_gigognes = {
  type: 'accessories',
  name: 'Tables gigognes',
  width: 230,
  height: 230,
  offsetX: 0,
  offsetY: 0,
  offsetHeight: 0,
  offsetWidth: 0,
  image: `${base}/img/tables_gigognes.png`,
  zIndex: 2,
  dragGrid: dragGridBase,
  realWidthBase: 46,
  realDepth: 43,
  realHeightBase: 77,
}

export const allComponents = {
  gridGF,
  gridMF,
  gridPF,
  gridGS,
  gridMS,
  board40x15,
  board60x15,
  board80x15,
  board40x20,
  board60x20,
  board80x20,
  board60x30_t2,
  board60x30_t3,
  board60x30_t2_left,
  board60x30_t2_right,
  board80x30_t2,
  board80x30_t2_left,
  board80x30_t2_right,
  board80x30_t3,
  desk60x50,
  desk80x50,
  potHolder_11,
  potHolder_11_with_pot,
  potHolder_15,
  potHolder_15_with_pot,
  hooks,
  vaseHolder_10,
  vaseHolder_15,
  frameHolder_40,
  computerHolder,
  hangerHolder,
  glassesHolder_with_glasses,
  ps40,
  ps60,
  wardrobe40_with_hanger,
  wardrobe60_with_hanger,
  wardrobe80_with_hanger,
  zenith_1_ppot,
  zenith_1_pver,
  halo_2_ppot,
  halo_2_pver,
  lumi_1,
  flux_2,
  echo_1,
  onde_2,
  tables_gigognes,
}

export const componentsReferences = {
  gridGF: 'grille_gf_public',
  gridMF: 'grille_mf_public',
  gridPF: 'grille_pf_public',
  gridGS: 'grille_80_44',
  gridMS: 'grille_60_44',
  board40x15: 'planche_40_15',
  board60x15: 'planche_60_15',
  board80x15: 'planche_80_15',
  board40x20: 'planche_40_20',
  board60x20: 'planche_60_20',
  board80x20: 'planche_80_20',
  board60x30_t2: 'planche_60_30',
  board60x30_t3: 'planche_60_30',
  board60x30_t2_left: 'planche_60_30',
  board60x30_t2_right: 'planche_60_30',
  board80x30_t2: 'planche_80_30',
  board80x30_t2_left: 'planche_80_30',
  board80x30_t2_right: 'planche_80_30',
  board80x30_t3: 'planche_80_30',
  desk60x50: 'planche_60_50',
  desk80x50: 'planche_80_50',
  potHolder_11: 'porte_pot_public',
  potHolder_11_with_pot: 'porte_pot_public',
  potHolder_15: 'porte_pot_15_public',
  potHolder_15_with_pot: 'porte_pot_15_public',
  hooks: 'crochets_public',
  vaseHolder_10: 'porte_vase_10_public',
  vaseHolder_15: 'porte_vase_15_public',
  frameHolder_40: 'porte_cadre_40_public',
  computerHolder: 'porte_ordi_public',
  hangerHolder: 'porte_cintre',
  glassesHolder_with_glasses: 'porte_verres',
  ps40: 'ps_40_public',
  ps60: 'ps_60_public',
  wardrobe40_with_hanger: 'porte_tringle_40',
  wardrobe60_with_hanger: 'porte_tringle_60',
  wardrobe80_with_hanger: 'porte_tringle_80',
  wardrobe40: 'porte_tringle_40',
  wardrobe60: 'porte_tringle_60',
  wardrobe80: 'porte_tringle_80',
  zenith_1_ppot: 'bom_lampe1_ppot',
  zenith_1_pver: 'bom_lampe1_pverre',
  halo_2_ppot: 'bom_lampe2_ppot',
  halo_2_pver: 'bom_lampe2_pverre',
  lumi_1: 'bom_vase1',
  flux_2: 'bom_vase2',
  echo_1: 'bom_miroir1',
  onde_2: 'bom_miroir2',
  tables_gigognes: 'tables_gigognes',
}

export const refMaterials = {
  grille_gf_public: {
    withWood: false,
    withMetal: true,
  },
  grille_mf_public: {
    withWood: false,
    withMetal: true,
  },
  grille_pf_public: {
    withWood: false,
    withMetal: true,
  },
  grille_80_44: {
    withWood: false,
    withMetal: true,
  },
  grille_60_44: {
    withWood: false,
    withMetal: true,
  },
  planche_40_15: {
    withWood: true,
    withMetal: true,
  },
  planche_60_15: {
    withWood: true,
    withMetal: true,
  },
  planche_80_15: {
    withWood: true,
    withMetal: true,
  },
  planche_40_20: {
    withWood: true,
    withMetal: true,
  },
  planche_60_20: {
    withWood: true,
    withMetal: true,
  },
  planche_80_20: {
    withWood: true,
    withMetal: true,
  },
  planche_60_30: {
    withWood: true,
    withMetal: true,
  },
  planche_80_30: {
    withWood: true,
    withMetal: true,
  },
  planche_60_50: {
    withWood: true,
    withMetal: true,
  },
  planche_80_50: {
    withWood: true,
    withMetal: true,
  },
  porte_pot_public: {
    withWood: false,
    withMetal: true,
  },
  porte_pot_15_public: {
    withWood: false,
    withMetal: true,
  },
  porte_vase_10_public: {
    withWood: false,
    withMetal: true,
  },
  porte_vase_15_public: {
    withWood: false,
    withMetal: true,
  },
  porte_cadre_40_public: {
    withWood: false,
    withMetal: true,
  },
  porte_ordi_public: {
    withWood: false,
    withMetal: true,
  },
  porte_cintre: {
    withWood: false,
    withMetal: true,
  },
  crochets_public: {
    withWood: false,
    withMetal: true,
  },
  ps_40_public: {
    withWood: false,
    withMetal: true,
  },
  ps_60_public: {
    withWood: false,
    withMetal: true,
  },
  porte_tringle_40: {
    withWood: false,
    withMetal: true,
  },
  porte_tringle_60: {
    withWood: false,
    withMetal: true,
  },
  porte_tringle_80: {
    withWood: false,
    withMetal: true,
  },
  bom_lampe1_ppot: {
    withWood: false,
    withMetal: true,
  },
  bom_lampe1_pverre: {
    withWood: false,
    withMetal: true,
  },
  bom_lampe2_ppot: {
    withWood: false,
    withMetal: true,
  },
  bom_lampe2_pverre: {
    withWood: false,
    withMetal: true,
  },

  bom_vase1: {
    withWood: false,
    withMetal: true,
  },
  bom_vase2: {
    withWood: false,
    withMetal: true,
  },
  bom_miroir1: {
    withWood: false,
    withMetal: true,
  },
  bom_miroir2: {
    withWood: false,
    withMetal: true,
  },
  tables_gigognes: {
    withWood: true,
    withMetal: true,
  },
}
